import React, { useState, useEffect } from "react";
import { ArrowRight, Menu, X } from "lucide-react";
import { announcement, nav } from "../mock";
import naariLogo from "../assets/naari-logo.jpg";

const Logo = ({ size = 44 }) => (
  <img
    src={naariLogo}
    alt="naari — Celebrating Her"
    className="rounded-full object-cover shrink-0"
    style={{ width: size, height: size }}
  />
);

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="sticky top-0 z-50">
      {/* Announcement */}
      <div
        className="w-full text-center py-2.5"
        style={{ background: "var(--wine)", color: "var(--cream)" }}
      >
        <span className="font-mono2" style={{ letterSpacing: "0.24em", fontSize: "0.62rem" }}>
          {announcement}
        </span>
      </div>

      {/* Nav */}
      <header
        className="w-full transition-all duration-500"
        style={{
          background: scrolled ? "rgba(244,237,224,0.9)" : "var(--cream)",
          backdropFilter: scrolled ? "blur(10px)" : "none",
          borderBottom: scrolled ? "1px solid rgba(89,26,32,0.08)" : "1px solid transparent",
        }}
      >
        <div className="max-w-[1360px] mx-auto px-6 md:px-10 flex items-center justify-between h-[88px]">
          <button onClick={() => scrollTo("#top")} className="flex items-center gap-3">
            <Logo size={64} />
            <span className="eyebrow hidden sm:block" style={{ color: "var(--ink)" }}>
              Celebrating Her
            </span>
          </button>

          <nav className="hidden lg:flex items-center gap-10">
            {nav.map((n) => (
              <button
                key={n.label}
                onClick={() => scrollTo(n.href)}
                className="nav-link font-body text-[0.95rem]"
                style={{ color: "var(--ink)" }}
              >
                {n.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-4">
            <button
              onClick={() => scrollTo("#the-edit")}
              className="btn-wine btn-3d hidden md:flex items-center gap-2 rounded-full px-6 py-3 font-mono2"
              style={{ fontSize: "0.66rem", letterSpacing: "0.16em" }}
            >
              FIND YOUR SAREE <ArrowRight size={14} />
            </button>
            <button className="lg:hidden" onClick={() => setOpen(!open)} style={{ color: "var(--wine)" }}>
              {open ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="lg:hidden px-6 pb-6 flex flex-col gap-4" style={{ background: "var(--cream)" }}>
            {nav.map((n) => (
              <button
                key={n.label}
                onClick={() => scrollTo(n.href)}
                className="text-left font-display text-2xl"
                style={{ color: "var(--wine)" }}
              >
                {n.label}
              </button>
            ))}
            <button
              onClick={() => scrollTo("#the-edit")}
              className="btn-wine flex items-center justify-center gap-2 rounded-full px-6 py-3 font-mono2 mt-2"
              style={{ fontSize: "0.66rem", letterSpacing: "0.16em" }}
            >
              FIND YOUR SAREE <ArrowRight size={14} />
            </button>
          </div>
        )}
      </header>
    </div>
  );
};

export { Logo };
export default Header;
